module.exports = __webpack_public_path__ + "1ac8b99e5fd4b143cd46d7e041568330.fbx";